// Per-demographic-question tables (response label, count, percentage-of-total).

import React from "react";
import { Typography } from "@material-tailwind/react";
import {
    GobbyTable,
    GobbyTableHead,
    GobbyTableBody,
    GobbyTableRow,
    GobbyTableHeader,
    GobbyTableCell,
} from "components/ui/gobby-table";

export function DemographicsSection({ pieDemographicData }) {
    return (
        <div className="mb-6">
            <Typography variant="h5" className="mb-1">
                Demographics
            </Typography>
            {!!(pieDemographicData && pieDemographicData?.length > 0) && (
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                    {pieDemographicData.map((question) => (
                        <div key={question.Question_UID} className="bg-platinumlight p-4 rounded-lg">
                            <Typography variant="h6">
                                {question.Question || "N/A"}
                            </Typography>
                            <GobbyTable>
                                <GobbyTableHead>
                                    <GobbyTableRow>
                                        <GobbyTableHeader>Response</GobbyTableHeader>
                                        <GobbyTableHeader>Count</GobbyTableHeader>
                                        <GobbyTableHeader>Percentage</GobbyTableHeader>
                                    </GobbyTableRow>
                                </GobbyTableHead>
                                <GobbyTableBody>
                                    {[...question.pieData].sort((a, b) => b.value - a.value).map((answer) => (
                                        <GobbyTableRow key={answer.answer_id}>
                                            <GobbyTableCell>{answer.label}</GobbyTableCell>
                                            <GobbyTableCell>{answer.value}</GobbyTableCell>
                                            <GobbyTableCell>
                                                {((answer.value / question.pieData.reduce((acc, a) => acc + a.value, 0)) * 100).toFixed(2)}%
                                            </GobbyTableCell>
                                        </GobbyTableRow>
                                    ))}
                                </GobbyTableBody>
                            </GobbyTable>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
